import { FileTextOutlined, SignatureFilled } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Space, Tooltip } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const ModuleListNameWrapper = styled.span`
  font-size: 16px;
  .anticon {
    margin-right: 4px;
    /* opacity: 0.65; */
    font-size: 1em;
  }
`;

export interface IModuleListNameProps {
  name?: string;
  shouldSign?: boolean;
}

/**
 * Nome di un modulo con icona per vista in lista nel frontend
 */
export function ModuleListName(props: IModuleListNameProps) {
  const { name, shouldSign } = props;
  const { t } = useTranslation();

  if (!name) return null;

  return (
    <ModuleListNameWrapper>
      <Space>
        <FileTextOutlined aria-hidden />
        {name}
        {shouldSign && (
          <Tooltip title={t('module-listname.da-firmare', 'Da firmare')}>
            <SignatureFilled
              aria-label={t('module-listname.da-firmare', 'Da firmare')}
            />
          </Tooltip>
        )}
      </Space>
    </ModuleListNameWrapper>
  );
}
